import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloseCross = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 13.3333 13.3333"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      d="M1 1L12.3333 12.3333M12.3333 1L1 12.3333"
    />
  </svg>
);
export default SvgCloseCross;
